/**
 * Permet d'afficher un élément au clic sur un autre élément.
 *
 * @param {string} listenerElementSelector L'élément qui écoutera le clic
 * @param {string} targetElementSelector L'élément à afficher
 */
export const displayOnClick = (
  listenerElementSelector,
  targetElementSelector
) => {
  const listenerElement = document.querySelector(listenerElementSelector);
  const targetElement = document.querySelector(targetElementSelector);

  const clickListener = () => {
    if (targetElement.style.display === 'none') {
      targetElement.style.removeProperty('display');
    }
  };

  listenerElement.addEventListener('click', clickListener);
};
